export default __webpack_public_path__ + "static/media/Amulet of Orastes.cb222ec8.jpg";